class SidebarIcon extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('li.t4s-cat-item');
    this.id_content = this.getAttribute('aria-controls');
    this.svg = this.querySelector('svg');
    this.control = this.parent.querySelector(`#${this.id_content}`);
    this.addEventListener('click', () => {
      this.Open ? this.closeContent() : this.openContent();
    })
  }
  get Open() {
    return this.hasAttribute('open')
  }
  static observedAttributes = ["open"]
  openContent() {

    this.control.style.setProperty('display', "block");
    this.svg.classList.add('rotated');
    this.setAttribute('open', '');
  }
  closeContent() {
    this.control.style.setProperty('display', "none");
    this.svg.classList.remove('rotated');
    this.removeAttribute('open');
  }
}
customElements.define('sidebar-icon', SidebarIcon);

(function () {
  function highlightActiveBreadcrumbFilter() {
    // 1. Get the text from the breadcrumb's active filter span
    const activeSpan = document.querySelector('.t4s-active-filter');
    if (!activeSpan) return;
    const targetText = activeSpan.textContent.trim();

    // 2. Select all filter items in the sidebar
    const filterItems = document.querySelectorAll('.t4s-filter__values li');

    filterItems.forEach(item => {
      const link = item.querySelector('a');
      if (!link) return;

      // 3. Extract text content excluding the count span
      let text = "";
      for (let node of link.childNodes) {
        // Determine if it's a text node
        if (node.nodeType === Node.TEXT_NODE) {
          text += node.textContent;
        }
      }
      text = text.trim();

      // 4. Compare and add class
      if (text === targetText) {
        // Only add 'current' class, avoiding 'is--selected' to prevent triggering filter logic
        item.classList.add('current');
      }
    });
  }

  // Run when DOM is ready
  document.addEventListener('DOMContentLoaded', highlightActiveBreadcrumbFilter);

  // Run when facets are loaded (dynamic updates)
  // Checking for jQuery and the custom event used in facets.min.js
  if (typeof jQuery_T4NT !== 'undefined') {
    jQuery_T4NT(document).on('facets:loaded sidebar:facets', function () {
      setTimeout(highlightActiveBreadcrumbFilter, 100);
    });
  }
})();